var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// @flow
// @ts-nocheck
import React, { Component } from 'react';
// utils
import { connect } from 'react-redux';
import { toJS } from '@shared/utils/immutable';
// actions
import { getIntro as getInspirationsIntro } from '@store/inspiration/actions';
// selectors
import { selectIntro as selectInspirationIntro, selectShouldLoadIntro, selectIntroLoading, } from '@store/inspiration/selectors';
// components
import Session from 'containers/Session';
import Page from 'pages/InspirationIntro';
var InspirationIntroComp = /** @class */ (function (_super) {
    __extends(InspirationIntroComp, _super);
    function InspirationIntroComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InspirationIntroComp.prototype.componentDidMount = function () {
        var shouldLoadIntro = this.props.shouldLoadIntro;
        if (shouldLoadIntro) {
            this.props.getInspirationsIntro();
        }
    };
    InspirationIntroComp.prototype.render = function () {
        var _a = this.props, intro = _a.intro, introLoading = _a.introLoading;
        return (_jsx(Session, { children: function (sessionProps) { return (_jsx(Page, __assign({}, sessionProps, { intro: intro, introLoading: introLoading }), void 0)); } }, void 0));
    };
    return InspirationIntroComp;
}(Component));
export var InspirationIntro = InspirationIntroComp;
var select = function () { return function (state, props) { return ({
    intro: selectInspirationIntro(state),
    shouldLoadIntro: selectShouldLoadIntro()(state, parseInt(props.match.params.genderId, 10)),
    introLoading: selectIntroLoading(state),
}); }; };
export default connect(select, {
    getInspirationsIntro: getInspirationsIntro,
})(toJS(InspirationIntro));
